import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/pro-regular-svg-icons";

interface paymentActionCellProps {
    data: any;
}

interface paymentActionCellState {
    paymentId: number;
}

class ActionCell extends React.Component<paymentActionCellProps> {
    state: paymentActionCellState;

    constructor(props: paymentActionCellProps) {
        super(props);
        this.state = {
            paymentId: this.props.data.data.paymentId,
        };
    }

    componentDidMount() {}

    render() {
        return (
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex">
                    <Link
                        title="Edit"
                        className={(false ? "disabled " : "") + "icon-btn"}
                        to={{
                            pathname: "/AddEditPaymentForm",
                            state: {
                                id: this.state.paymentId.toString(),
                            },
                        }}
                    >
                        <FontAwesomeIcon icon={faPen} />
                    </Link>
                </div>
            </div>
        );
    }
}

export default ActionCell;
